import { useMemo } from "react";
import { useDispatch } from "react-redux";

import { useQueryClient } from "@tanstack/react-query";

import { apiThatThrows } from "containers/Request";
import { FilterSuggestion } from "hooks/tivoApps";
import { ApiResponse } from "types/api";

// Cache results for 5 minutes.
const STALE_TIME = 300000;

export const useFiltersSuggestions = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const fetchSuggestions = useMemo(
    () =>
      (
        queryParams: { for_filter: string; text: string },
        abortSignal: AbortSignal
      ) =>
        queryClient.fetchQuery<ApiResponse<FilterSuggestion[]>>({
          queryKey: ["suggestions", queryParams],
          queryFn: async () =>
            await dispatch(
              apiThatThrows.getTiVoSuggestions.action({
                queryParams,
                abortSignal,
              })
            ),
          staleTime: STALE_TIME,
        }),
    [dispatch, queryClient]
  );

  return { fetchSuggestions };
};
